import React from "react";
import { makeStyles } from "tss-react/mui";
import "@mui/material";
import "@mui/x-data-grid";
import "uuid";
import "../../alerts/InfoMessage.js";
import "../../alerts/NoAccessInfoMessage.js";
import "../../alerts/Message.style.js";
import "react-intl";
import "../../alerts/InfoAlert.js";
import "../../alerts/InfoMessageHoc.js";
import "../../checkbox/StyledCheckbox.js";
import "fast-deep-equal/es6";
import "../../pagination/StyledPagination.js";
import "../../data-grid/mui/GridColumnsButton.js";
import "../../data-grid/mui/GridColumnsPanel.js";
import "../../data-grid/mui/hooks/useGridCellStyle.js";
import "../../data-grid/mui/hooks/useGridLocalization.js";
import "fast-deep-equal";
import "../../data-grid/mui/hooks/useGridStyle.js";
import "immer";
import "../../data-grid/mui/cells/InvalidDataCell.js";
import { CurrencyCell } from "../../data-grid/mui/cells/CurrencyCell.js";
import { DateCell } from "../../data-grid/mui/cells/DateCell.js";
import { withEmptyCheck } from "../../label/EmptyLabel.js";
import "../../label/LabelHoc.js";
import "../../tooltip/Tooltip.js";
import "moment-timezone";
import "../../tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../../tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../../tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import "../../data-grid/mui/cells/LabelsCell.js";
import "../../data-grid/mui/cells/NumberCell.js";
import "../../data-grid/mui/cells/TextCell.js";
import "../../link/LinkHOC.js";
import "../../link/LinkButton.js";
import "../../chip/ChipRenderer.js";
import "../../chip/Chips.js";
import "../../chip/ListWithChipTooltip.js";
import "../../chip/SquaredChipList.js";
import "../../icons/Icon.js";
import "../../icons/ExpandMoreIcon.js";
import "../../data-grid/mui/cells/ActionWithConfirmationButton.js";
import "../../data-grid/mui/cells/TextListWithTooltipCell.js";
import "../../data-grid/mui/cells/DurationCell.js";
import "../../data-grid/mui/cells/PercentCell.js";
import "../../modal/BulkModalContent.js";
import "../../modal/BulkModalProvider.js";
import "../../modal/ModalButtons.js";
import "../../modal/Modal.style.js";
import "../../button/Buttons.js";
import "../../button/EditButton.js";
import "../../error/ErrorAccordion.js";
import "../../error/ErrorDetails.js";
import "../../error/localize.js";
import "../../error/ErrorModal.js";
import "../../error/GlobalServerErrorMessage.js";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "../../modal/types.js";
import "../../modal/ActionConfirmationModal.js";
import "../../data-grid/mui/cells/ButtonCell.js";
const useClasses = makeStyles()((theme) => ({
  currencyWithDateCellDate: {
    marginLeft: theme.spacing(1),
    color: theme.palette.text.secondary,
    width: "max-content"
  }
}));
function CurrencyWithDateCellInner({ value }) {
  const { classes } = useClasses();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CurrencyCell, { value: value.amount, currency: value.currency }), /* @__PURE__ */ React.createElement("div", { className: classes.currencyWithDateCellDate }, /* @__PURE__ */ React.createElement(DateCell, { value: value.date })));
}
const CurrencyWithDateCell = withEmptyCheck(CurrencyWithDateCellInner);
export {
  CurrencyWithDateCell
};
//# sourceMappingURL=CurrencyWithDateCell.js.map
